/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Finish_TournamentInputs */



/**
* | output |
* | --- |
* | "Finish Tournament" |
*
* @param {Overview_Finish_TournamentInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_finish_tournament = /** @type {((inputs?: Overview_Finish_TournamentInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Finish_TournamentInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer le tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finalizar torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finalizar Torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Concludi Torneo")
	return /** @type {LocalizedString} */ ("Finish Tournament")
});